import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { NumTreeEstimate, PlotMbr } from "../models/Plot";
import { PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { IndexData, IndexType } from "../models/SatelliteIndex";
import axios, { CancelTokenSource } from "axios";

export default class SatelliteIndexApi {
    private http: HTTPClient;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient) {
        this.http = http;
        this.cancelTokenSource = null;
    }

    async getAvailableIndexes(): Promise<IndexType[]> {
        const res = await this.http.get(`/indexes/api/v1/lot/map/indexes`);
        return res.data;
    }
    async getSatelliteIndexData(
        subject_id: number,
        isSupplyChain: boolean,
        campaign: number,
        indexCode: string,
        bb_ux: number | null,
        bb_uy: number | null,
        bb_lx: number | null,
        bb_ly: number | null,
        refDate: Date | null,
        plotId: number | null,
    ): Promise<IndexData> {
        if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel();
        }
        this.cancelTokenSource = axios.CancelToken.source();
        const dateWithAddedHours = refDate ? new Date(refDate) : undefined;
        if (dateWithAddedHours) {
            dateWithAddedHours.setHours(12, 0, 0, 0);
        }
        const dateISO = dateWithAddedHours ? dateWithAddedHours.toISOString().split("T")[0] : undefined;
        const defaultUrl = `/indexes/api/v1/lot/map/subjects/${subject_id}/campaign/${campaign}/index/${indexCode}`;
        const supplyChainUrl = `/indexes/api/v1/lot/map/scs/${subject_id}/campaign/${campaign}/index/${indexCode}`;
        const res = await this.http.get(
            !isSupplyChain ? defaultUrl : supplyChainUrl,
            {
                params: {
                    bb_ux: bb_ux ? bb_ux : undefined,
                    bb_uy: bb_uy ? bb_uy : undefined,
                    bb_lx: bb_lx ? bb_lx : undefined,
                    bb_ly: bb_ly ? bb_ly : undefined,
                    ref_date: dateISO,
                    plot_id: plotId ? plotId : undefined,
                },
                cancelToken: this.cancelTokenSource?.token
            })
        return res.data;
    }
    async getSatelliteIndexImage(externalId: number, indexCode: string, pathImage: string): Promise<string> {
        const res = await this.http.get(`/indexes/api/v1/lot/ndvi/${externalId}/index/${indexCode}/image`, {
            params: {
                png: pathImage,
            },
            cancelToken: this.cancelTokenSource?.token
        });
        return res.data;
    }
}
